'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Record;

var _immutable = require('immutable');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EmailCapturePromptMetadata = (0, _immutable.Record)((_Record = {}, _defineProperty(_Record, _messageTypes.MESSAGE_TYPE_ID, _messageTypes.EMAIL_CAPTURE_PROMPT), _defineProperty(_Record, 'text', ''), _defineProperty(_Record, 'sentOutsideOfficeHours', false), _defineProperty(_Record, 'sentInAwayMode', false), _Record), 'EmailCapturePromptMetadata');

exports.default = EmailCapturePromptMetadata;
module.exports = exports['default'];